module.exports = __webpack_public_path__ + "img/tractor-red.bb2f2885.svg";